<template>
  <div class="chat_box">
    <div class="prof seller">
      <div class="inner">
        <img
          src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
          alt=""
        />
      </div>
    </div>
    <div class="chat_con perce_chat_con" v-if="isCustomer">
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          꼭! 상담 후 가입정보는 <br />가입신청서를 통해 전달하세요!
        </div>
        <div class="chat_msg system">
          가입신청서를 이용하지 않은 직거래는 문제가 생겼을 때 퍼스의 보호를
          받을 수 없습니다.<br />
          매장이 이름 연락처 등 개인정보부터 물어본다면? 퍼스에게 알려주세요!
        </div>
      </div>
      <button class="chat_txt_btn" @click="openInternetQuotationList">
        <i class="i_chat_write_form"></i>가입신청서 작성하기
      </button>
      <button class="chat_txt_btn" @click="reportStore">
        <i class="i_chat_report"></i>매장신고하기
      </button>
    </div>
    <div class="chat_con perce_chat_con" v-else>
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          고객님과 계약시 반드시<br />
          가입신청서를 이용해주세요!
        </div>
        <div class="chat_msg system">
          가입신청서는 열람권을 통해서만 열람이 가능하며, 부족한 열람권은
          제로노트에서 구매 가능합니다. (가입신청서가 아닌 직거래 유도 시 제재의
          대상이 됩니다)
        </div>
      </div>
      <button class="chat_txt_btn" @click="sendText(text1)">
        <i class="i_chat_chat"></i>{{ text1 }}
      </button>
      <button class="chat_txt_btn" @click="sendText(text2)">
        <i class="i_chat_chat"></i>{{ text2 }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatRoomInternetApplyNotice',
  description: '인터넷 신청서 시스템 알림',
  props: {
    isCustomer: Boolean,
  },
  data() {
    return {
      text1: '안녕하세요! 반갑습니다!',
      text2: '가입을 위해 가입신청서를 보내주세요!',
    };
  },
  methods: {
    openInternetQuotationList() {
      this.$emit('openInternetQuotationList');
    },
    reportStore() {
      this.$emit('report');
    },
    sendText(val) {
      this.$emit('send', val);
    },
  },
};
</script>

<style></style>
